import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Slider from 'react-slick';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import Loading from '../components/Loading';
import Drawer from '@mui/material/Drawer';
import { Helmet } from 'react-helmet';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from 'react-toastify';
import Loader from '../components/Loader';

function Subscription() {

  const navigate = useNavigate();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [couponCode, setCouponCode] = useState('');
  const [subscriptionId, setSubscriptionId] = useState('');
  const [priceid, setPriceId] = useState('');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [couponMessage, setCouponMessage] = useState('');
  const [notFound, setNotFound] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  
  const errorRef = useRef(null);
  const successMessageRef = useRef(null);

  useEffect(() => {
    if ((error && errorRef.current) || (successMessage && successMessageRef.current)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [error, successMessage]);

  useEffect(() => {
    if (error && errorRef.current) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [error]);

  useEffect(() => {
    const fetchSubscriptions = async () => {

      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          url: `${params.baseURL}${params.endpoints.getSubscriptions}`,
          data: formData
        });

        if (response.data.status === 'found') {
          setData(response.data.subscriptions);
          setNotFound(false);
          if (response.data.subscriptions.length > 0) {
            setSelectedPlan(response.data.subscriptions[0]);
          }
        } else if (response.data.status === 'notfound') {
          setNotFound(true); 
          //{/*setError(response.data.msg);*/}
        } else {
          setError(response.message || 'Error in fetching data.');
        }
      } catch (error) {
        setError('Error fetching My Subscriptions.');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: data.length > 1,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
  };

  const openCouponBox = (id, price_id) => {
    setDrawerOpen(true);
    setSubscriptionId(id);
    setPriceId(price_id);
  };

  const applyCoupon = async (couponCode) => {

    const hostData = getItemFromLocalStorage('hostProfile');

    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('subscription_id', subscriptionId);
    formData.append('price_variant_id', priceid);
    formData.append('coupon_code', couponCode);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.checkCoupon}`,
        data: formData
      });

      if (response.data.status === 'ok') {
        setIsPopupOpen(true);
        setDrawerOpen(false);
        setCouponMessage(response.data.msg);
      } else if (response.data.status === 'error') {
        setError(response.data.list);
      } else {
        setError('Error in saving data.');
      }
    } catch (err) {
      setError('An error occurred while saving data.');
    }
  }

  const skipCoupon= () => {
    setIsPopupOpen(true);
    setDrawerOpen(false);
    setCouponMessage('');
  }

  const handlePayment = async (id, price_id) => {

    const hostData = getItemFromLocalStorage('hostProfile');

    let formData = new FormData();
    formData.append('subscription_id', id);
    formData.append('price_variant_id', price_id);
    formData.append('token', hostData.host_access_token);
    formData.append('coupon_code', couponCode);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.subscribeIt}`,
        data: formData
      });

      if (response.data.status === 'ok') {
        /*if (response.data.captain_subscription_info.subscription_status === 1)  { 
          openRazorpay(response);
        } else {
          setSuccessMessage(response.data.msg)
        }*/
        openRazorpay(response.data);
      } else if (response.data.status === 'error') {
        setError(response.data.list);
      } else {
        setError('Error in saving data.');
      }
    } catch (err) {
      setError('An error occurred while saving data.');
    }
  }

  const openRazorpay = (response) => {
    const { pgKey, orderInfo, captain_subscription_info } = response;

    const options = {
      key: pgKey,
      amount: Number(captain_subscription_info.final_total) * 100,
      currency: captain_subscription_info.subscription_currency,
      name: "Stay",
      description: captain_subscription_info.subscription_name,
      order_id: orderInfo,
      handler: function (razorpayResponse) {
        verifyPayment({
          host_subscription_id: captain_subscription_info.host_subscription_id,
          razorpay_payment_id: razorpayResponse.razorpay_payment_id,
          razorpay_order_id: razorpayResponse.razorpay_order_id,
          razorpay_signature: razorpayResponse.razorpay_signature,
        });
      },
      prefill: {
        name: "Host Name",
        email: "host@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#00AEEF",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const verifyPayment = async (paymentData) => {
    const hostData = getItemFromLocalStorage('hostProfile');

    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('payment_id', paymentData.razorpay_payment_id);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.verifyPg}`,
        data: formData
      });

      if (response.data.status === "ok") {
        toast.success("Subscription purchased successfully!");
        setTimeout(() => {
          navigate('/my-subscription');
        }, 1500);
      } else {
        toast.error("Payment verification failed!");
      }
    } catch (error) {
      console.error("Verification failed:", error);
    }
  };

  const handleYesClick = () => {
    setDrawerOpen(false);
    setIsPopupOpen(false);
    handlePayment(subscriptionId, priceid);
  };

  const handleToggle = (plan) => {
    setSelectedPlan(plan);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>

        <Helmet>
          <title>Subscription Plans</title>
        </Helmet>
        <article>
          {successMessage && <div className="alert alert-success mb-4" ref={successMessageRef}>{successMessage}</div>}
          {error && <div className="alert alert-danger" ref={errorRef}>{error}</div>} 

          {notFound ? (
            <div className="text-center text-uppercase">
              <img src='/assets/img/no_subscription_found.png' alt='' style={{width:'300px'}} className='img-fluid' />
              <h4>Subscription Unavailable</h4>
            </div>
          ) : (
            <section className="row row--wrap mt-5"> 
              <div className='col-md-6 mx-auto'>
                <div className='spheading'>
                  <img src='/assets/img/title/ws_plus.svg' className='img-fluid img-title' alt='' />
                </div>
                <div className="subscription-pricing-header">
                  {data.map((plan) => (
                    <div
                      key={plan.subscription_id}
                      onClick={() => handleToggle(plan)}
                      className={`pricing-header-btn ${
                        selectedPlan.subscription_id === plan.subscription_id
                          ? 'phb-active'
                          : ''
                      }`}
                    >
                      {
                        selectedPlan.subscription_id === plan.subscription_id
                          ? <span className='subscription-pricing-check'><i class="fas fa-check-circle"></i></span>
                          : ''
                      }
                      {plan.subscription_pricing.map(price => (                              
                        <React.Fragment key={price.billing_cycle_title}>
                          <span className='bct-txt'>{price.tenure_title}</span>
                          <span style={{fontSize: '30px'}}>{price.final_price_display}</span>
                          <span className='bct-txt'>{price.billing_cycle_title}</span>
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                </div>

                <div className="pricing-card">
                  <div className="pricing-card__desc">
                    <div className="pricing-card__desc_head">
                      <div className="pricing-card__desc_tier">
                        {selectedPlan.subscription_features.map(feature => (
                          <div className='pricing-card__desc_span'>
                            <span className='subscription-pricing-ftr-check'>
                              {feature.yesorno ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                            </span>
                            <span className='pricing-card__desc_line'>{feature.feature_title}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <span class="pricing-line"></span>
                  {selectedPlan.subscription_pricing.map(price => (
                      <button className="pricing-button pricing-card__action" 
                          onClick={() => openCouponBox(
                            selectedPlan.subscription_id, 
                            price.price_variant_id
                          )}>
                          SUBSCRIBE
                      </button>
                  ))}
                </div>
              </div>
            </section>
          )}
        </article>

        <Drawer
          anchor='bottom'
          className='drawer'
          open={isDrawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <div className='drawer-content post-popup'>
              <div className='post-popup-box' style={{padding: '50px 10px', width: '500px', maxWidth: '500px'}}>
                <div>
                  <span className='drawer-close-btn' onClick={() => setDrawerOpen(false)}>
                    <img src={'/assets/img/icons/close_icon.svg'} className='w-100' alt='' />
                  </span>
                </div>
                  <div className='popup-title' style={{marginBottom: '1rem', fontWeight: '600' }}>REEDEM COUPON</div>
                  <div className='popup-options'>
                    <div>
                      <div className="form-floating">
                        <input type="text" id="coupon_code" className="form-control" value={couponCode} onChange={(e) => setCouponCode(e.target.value.toUpperCase())} required />
                        <label htmlFor="coupon_code">Enter Coupon Code</label>
                      </div>
                    </div>
                    <div className='coupon-drawer-footer'>
                      <button className="btn btn-primary" onClick={() => skipCoupon()}>Skip</button>
                      <button className="btn btn-success" onClick={() => applyCoupon(couponCode)}>Proceed</button>
                    </div>
                  </div>
              </div>
          </div>
        </Drawer>

        {isPopupOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm!</h5>
                <span className="popup-close" onClick={() => setIsPopupOpen(false)}>&times;</span>
              </div>
              <div className="modal-body">
                <p>Would you like to subscribe this plan. {couponMessage}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setIsPopupOpen(false)}>No</button>
                <button type="button" className="btn" onClick={handleYesClick}>Yes</button>
              </div>
            </div>
          </div>
        )}

    </div>
  )
}

export default Subscription;